import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ThemeService {
  private currentTheme: "light" | "dark" = "dark";
  private themeSubject = new BehaviorSubject<"light" | "dark">(
    this.currentTheme
  );
  public theme$ = this.themeSubject.asObservable(); // Allows global subscription

  constructor() {
    // Load theme from user settings (localStorage)
    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    if (savedTheme) {
      this.currentTheme = savedTheme;
    }
    this.applyTheme(this.currentTheme);
  }

  public setTheme(theme: "light" | "dark"): void {
    this.currentTheme = theme;
    localStorage.setItem("theme", theme);
    this.applyTheme(theme);
  }

  private applyTheme(theme: "light" | "dark"): void {
    document.documentElement.setAttribute("data-theme", theme);
    this.themeSubject.next(theme);
  }

  public getTheme(): "light" | "dark" {
    return this.currentTheme;
  }
}
